export default "__VITE_ASSET__daeeadaf__"